import Vue from "vue";

import TimeRange from "./TimeRange";

Vue.component("time-range", TimeRange);
